<template>
  <div class="top-column">
    <ol>
      <li v-for="(item, index) in items" :key=index>
        <h3>{{item.title}}</h3>
        <p>{{item.text}}</p>
        <sns-field v-if="item.title === 'about me'"></sns-field>
      </li>
    </ol>

  </div>
</template>

<script>

import SnsField from '@/components/SnsFieldMobile'

export default {
  name: 'TopColumn',
  data () {
    return {
      items: [
        {title: 'about me', text: 'churabou,  20 years old, iOS Enginner loves UI/UX \n playing piano, reading book '},
        {title: 'Skills', text: 'html css javascript ruby Ruby on Rails \n mysql sqlite iOS swift c++ c# python'},
        {title: 'interest', text: 'Vue.js React.js Android kotolin design React Native Flutter go ML OpenCV OpenGL AR VR '}
      ]
    }
  },
  components: {
    SnsField
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.top-column ol {
  /* background-color: pink; */
  /* width: 90%; */
  /* display: inline-block; */
  /* text-align: center; */
}
.top-column h3 {
  color: pink;
  text-align: center;
}

.top-column p {
    text-align: center;
    color: darkgray;
}
/*  モバイルなら縦に表示*/
.top-column li {
  width: 90%;
  height: 300px;
  background-color: #fefefe;
  vertical-align: top;
}

/*  webなら横に表示 */
@media screen and (min-width:781px) {
 .top-column li {
  /* background-color: red; */
  width: 22%;
  display: inline-block;
  margin-right: 10px;
  /* margin-top: auto; */
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TopColumn.vue